module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAA6ElEQVRIibWUAQ2DMBAA7x1UAhKQgAQkIAEJkzAJSEDCJEwCEubglzZsCdDyQEuTJtA+f0//QFSVO4aI1MB4C0BEHPAGnncBBqBS1QYPKDmBFvgALtwXTl7NydvfWtEjEpGXP3tV7f+LBat/zI11i/VCyb2S/qLe7BVI7pWcgD62n92DhZKxkVn9QsloTAElm924DED4FZhxOUoeir2QvJmPZqNkNsBSMvFMeN2kBavg0c+TRYVmbT7xSGBnKZkCOAtyVMlkDyzIUSV3m5yCnFHStGgNOaukCYhAvJLd1eRRwAoy5CRXVb54gLXBGqH3xwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark.png
// module id = 1353
// module chunks = 0